module.exports = __webpack_public_path__ + "img/accel.69df222a.svg";